import address from './address.vue';
import companyAddress from './companyAddress.vue';
import dateTime from './dateTime.vue';
import image from './image.vue';
import number from './number.vue';
import strictImage from './strictImage.vue';
export const valueTypeMap = {
    dateTime,
    address,
    image,
    strictImage,
    number,
    companyAddress,
};
